import Footer from "./footer";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema } from "../seo/seoConfig";

export default function TermsAndConditions() {
    const seo = SEO_PAGES.terms;
    return (
        <>
            <SEO
                {...seo}
                schemas={[
                    getBreadcrumbSchema([
                        { name: "Home", path: "/" },
                        { name: "Terms & Conditions", path: "/terms-and-conditions" },
                    ]),
                ]}
            />
            <div className="min-h-screen mt-20 px-4 sm:px-6 lg:px-8" id="terms-and-conditions">
                <div className="max-w-4xl mx-auto">
                    <div className="mb-8">
                        <span className="inline-block bg-emerald-50 text-emerald-700 text-sm px-3 py-1 rounded-full font-medium mb-4">
                            Terms & Conditions
                        </span>
                        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[62.86px] font-400 leading-tight tracking-tight mb-6">
                            <span className="text-emerald-500">Terms & </span>
                            <span className="bg-gradient-to-r from-emerald-400 to-blue-600 bg-clip-text text-transparent">Conditions</span>
                        </h1>
                        <p className="text-gray-600 mb-8">
                            Welcome to PyCray Technologies. By accessing or using our website and services, you agree to comply with the following
                            terms and conditions. Please read them carefully.
                        </p>
                    </div>

                    <div className="space-y-8">
                        <section>
                            <h2 className="text-lg font-semibold mb-3">1. Acceptance of Terms</h2>
                            <p className="text-gray-600">
                                By using this website, you confirm your agreement to these terms. If you do not accept any of these terms, you are
                                prohibited from using or accessing this site.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">2. Services and Usage</h2>
                            <p className="text-gray-600 mb-2">PyCray Technologies offers IT services and products, as described on our website.</p>
                            <p className="text-gray-600">
                                Unauthorized use of our services, including reverse engineering, reselling, or misuse, is strictly prohibited.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">3. Intellectual Property</h2>
                            <p className="text-gray-600">
                                All content, including text, graphics, logos, and software, is the property of PyCray Technologies and is protected by
                                applicable intellectual property laws. You may not reproduce or redistribute any content without explicit permission.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">4. User Conduct</h2>
                            <p className="text-gray-600 mb-2">Users must not:</p>
                            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                                <li>Violate any applicable laws or regulations.</li>
                                <li>Use the website to distribute harmful or malicious content.</li>
                                <li>Attempt to gain unauthorized access to the website or its data.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">5. Privacy Policy</h2>
                            <p className="text-gray-600">
                                Your use of this website is also governed by our Privacy Policy, which explains how we collect, use, and protect your
                                personal data.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">6. Limitation of Liability</h2>
                            <p className="text-gray-600">
                                PyCray Technologies is not liable for any damages, including direct, indirect, incidental, or consequential damages,
                                arising from the use or inability to use our website or services.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">7. Third-Party Links</h2>
                            <p className="text-gray-600">
                                Our website may include links to third-party websites. PyCray Technologies is not responsible for the content,
                                policies, or practices of any third-party sites.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">8. Modification of Terms</h2>
                            <p className="text-gray-600">
                                We reserve the right to update or modify these terms at any time without prior notice. Your continued use of the
                                website constitutes acceptance of the revised terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">9. Governing Law</h2>
                            <p className="text-gray-600">
                                These terms are governed by the laws of Uttar Pradesh, India. Any disputes will be resolved in the courts of Uttar
                                Pradesh, India.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold mb-3">10. Contact Us</h2>
                            <p className="text-gray-600 mb-2">If you have any questions about these terms, please contact us at:</p>
                            <div className="text-gray-600 ml-4">
                                <p>Email: info@pycray.com</p>
                                <p>Address: B-7, First Floor, B Block, Sector 2, Noida, Uttar Pradesh, India 201301</p>
                            </div>
                        </section>

                        <p className="text-gray-600 italic mt-8">
                            By using our website, you confirm that you have read, understood, and agreed to these terms and conditions.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
